<script>
import MyVideoPlayer from "./MyVideoPlayer.vue";
import HeartLike from "./HeartLike.vue";
import {sendAppMessage} from "@/util/sendAppMessage";

export default {
  name: "VideoSlideItem",
  components: { HeartLike, MyVideoPlayer },
  props: ['index', 'currentIndex', 'isFull', 'src', 'poster', 'item', 'showPlayer', 'cacheIndex', 'giftOtherData'],
  emits: ['fullscreen', 'select', 'share', 'collect', 'like', 'bottom', 'give', 'comment'],
  data() {
    return {
      player: null,
      haveToken: "",
      onSaveTokenCopy: this.onSaveToken.bind(this),
      device: "ard"
    }
  },
  mounted() {
    let device = localStorage.getItem("device");
    if(device) {
      this.device = device;
    }
    // this.player = this.$refs.video || null;
    // if (this.index === this.currentIndex) {
    //   this.player && this.player.play();
    // }
    this.haveToken = !!localStorage.getItem("xxxxtoken");
    $bus.$on("saveToken", this.onSaveTokenCopy);
  },
  beforeDestroy() {
    $bus.$off("saveToken", this.onSaveTokenCopy);
  },
  watch: {
    currentIndex() {
      if(!this.isIncludedCacheIndex) return;
      this.$nextTick(() => {
        this.player = this.$refs.video;
        if (this.index === this.currentIndex) {
          this.player && this.player.play();
        }else {
          this.player && this.player.pause();
        }
      })
    },
    cacheIndex() {
      console.log("cacheIndex", this.cacheIndex);
    }
  },
  computed: {
    isIncludedCacheIndex() {
      return this.cacheIndex.includes(this.index);
    },
  },
  methods: {
    onSaveToken(token) {
      this.haveToken = !!token;
    },
    onCommentClick() {
      this.$emit("comment", this.item);
    },
    onFullScreenClick() {
      this.$emit('fullscreen');
      if(this.player) {
        this.player.fullscreen();
      }else {
        this.$nextTick(() => {
          this.player = this.$refs.video;
          this.player.fullscreen();
        })
      }
    },
    onSelectClick() {
      this.$emit('select', this.item);
    },
    onShareClick() {
      this.$emit('share', this.item);
    },
    onCollectClick(status) {
      this.$emit('collect', { index: this.index, status: status, video: this.item });
    },
    onLikeClick() {
      this.$emit("like", this.item);
    },
    onClickBottom() {
      this.$emit("bottom", this.item);
    },
    onClickKf() {
      this.$axios.get("/system/getServicePhone").then(res=>{
        if(res.code==10001){
          sendAppMessage({jump_type: 7, jump_url: res.data.enterprise_wechat_url})
        }
      })
    },
    onGiveClick() {
      this.$emit("give", this.item);
    },
    getButtonName() {
      if(this.item.jump_button_type == 2) {
        return "查看老师"
      }
      if(this.item.jump_button_type == 3) {
        return "查看课程"
      }
      if(this.item.jump_button_type == 5) {
        return "查看套餐"
      }
      if(this.item.jump_button_type == 12) {
        return "查看专辑"
      }
      return "跳转链接";
    }
  },
};
</script>

<template>
  <div :style="{'z-index': currentIndex === index ? 2 : 1}" class="player-container">
    <div class="player-container_inner">
      <h3 class="mb-4 text-white text-center font-bold px-3 video-title">{{ item.title }}</h3>
      <div class="player-container_inner_video">
        <MyVideoPlayer :device="device" @open-gift="onGiveClick" v-if="isIncludedCacheIndex" ref="video" :is-auto-play="index === currentIndex" :is-full="isFull" :item="item" :poster="poster" :video-src="src"></MyVideoPlayer>
        <div v-else style="padding-bottom: 56.2%"></div>
      </div>
      <div class="btns mt-4">
        <div class="btn py-1 px-2" @click="onFullScreenClick()">
          <svg class="icon" height="25" p-id="4167" t="1727164715670" version="1.1" viewBox="0 0 1024 1024" width="25" xmlns="http://www.w3.org/2000/svg"><path d="M285.866667 810.666667H384v42.666666H213.333333v-170.666666h42.666667v98.133333l128-128 29.866667 29.866667-128 128z m494.933333 0l-128-128 29.866667-29.866667 128 128V682.666667h42.666666v170.666666h-170.666666v-42.666666h98.133333zM285.866667 256l128 128-29.866667 29.866667-128-128V384H213.333333V213.333333h170.666667v42.666667H285.866667z m494.933333 0H682.666667V213.333333h170.666666v170.666667h-42.666666V285.866667l-128 128-29.866667-29.866667 128-128z" fill="#EFEFF4" p-id="4168"></path></svg>
          <span class="text-sm">全屏播放</span>
        </div>
        <div v-if="item.jump_button_type != 0" class="btn p-1 px-2" @click="onSelectClick()">
          <svg class="icon" height="25" p-id="5232" t="1727164923125" version="1.1" viewBox="0 0 1024 1024" width="25" xmlns="http://www.w3.org/2000/svg"><path d="M928.842245 512.091074c0-5.006014-0.846274-9.193383-1.086751-9.691733-0.182149-2.480494-1.028423-7.001461-1.815345-9.374508-0.210801-0.590448-0.484024-1.209548-0.724501-1.799996-0.424672-1.360997-0.876973-2.691295-1.390673-3.749394-76.871785-168.137395-242.376213-281.144168-411.782507-281.144168-169.375595 0-334.865697 112.902396-411.388535 280.130072-0.921999 1.815345-1.572822 3.553942-1.981121 5.066389-0.181125 0.49835-0.39295 0.967024-0.558725 1.406023-1.512447 4.430916-1.542122 7.514137-1.421372 6.712889-0.710175 3.251044-1.360997 9.722432-1.360997 9.722432-0.181125 1.949398-0.181125 3.50687 0.030699 5.442966 0 0 0.649799 5.65479 0.968048 6.80294 0.090051 1.602498 0.483001 3.931542 0.951675 6.048763l-0.030699 0c0.408299 1.814322 0.968048 3.568269 1.738597 5.291516 0.393973 1.330298 0.862647 2.570545 1.270946 3.507894 76.976162 168.166047 242.436588 281.20352 411.781484 281.20352 169.436994 0 334.941422-112.945375 410.936233-279.328823 1.177825-2.177596 1.935072-4.233418 2.448772-6.018064 0.2415-0.543376 0.454348-1.027399 0.604774-1.511423 1.331321-3.872191 1.602498-7.227612 1.481747-7.227612l-0.028653 0.029676C928.027693 520.921183 928.842245 516.89959 928.842245 512.091074zM872.717993 514.146896c-0.029676 0.121773-0.091074 0.272199-0.151449 0.393973-0.090051 0.36225-0.240477 0.785899-0.332575 1.209548-68.403926 147.420561-212.830293 246.337431-360.191502 246.337431-146.997935 0-291.168476-98.642624-360.252901-246.578931-0.166799-0.5137-0.287549-0.998747-0.468674-1.481747-0.030699-0.484024-0.12075-0.876973-0.150426-1.150196-0.060375-0.300852-0.12075-0.724501-0.166799-1.088798l0-0.3776c0.166799-0.620124 0.286526-1.239224 0.347924-1.919722 0.12075-0.36225 0.211824-0.710175 0.347924-1.103124C220.132094 360.89042 364.680235 261.928524 512.041444 261.928524c147.420561 0 291.940049 99.051947 360.161826 246.322082 0.060375 0.287549 0.121773 0.530073 0.212848 0.726547 0.060375 0.2415 0.119727 0.484024 0.240477 0.740874 0.151449 1.104147 0.272199 2.192945 0.423649 2.736321C872.899118 513.028423 872.809067 513.572822 872.717993 514.146896z" fill="#EFEFF4" p-id="5233"></path><path d="M512.041444 373.060601c-76.598562 0-138.954749 62.325487-138.954749 138.939399 0 76.598562 62.356187 138.954749 138.954749 138.954749 76.598562 0 138.954749-62.356187 138.954749-138.954749C650.996193 435.386088 588.640006 373.060601 512.041444 373.060601zM512.041444 595.372849c-45.935192 0-83.371826-37.406958-83.371826-83.371826 0-45.950542 37.436634-83.356476 83.371826-83.356476 45.964868 0 83.373873 37.406958 83.373873 83.356476C595.414293 557.965891 558.006312 595.372849 512.041444 595.372849z" fill="#EFEFF4" p-id="5234"></path></svg>
          <span class="text-sm">{{ getButtonName() }}</span>
        </div>
      </div>
      <div class="flex justify-around text-white mt-6">
        <HeartLike v-if="item.comment_status != 1 || device == 'ios'" :count="item.like_num || 0" @like="onLikeClick"></HeartLike>
        <div class="flex flex-col space-y-1 items-center">
          <svg v-if="item.is_collect" class="icon" height="100%" p-id="2104" t="1729222239914" version="1.1" viewBox="0 0 1025 1024" width="100%" xmlns="http://www.w3.org/2000/svg" @click="onCollectClick(false)"><path d="M794.444835 1023.90002c-9.098223 0-18.296426-2.299551-26.694786-6.898653L512.899824 876.428822l-254.850224 140.472564c-18.696348 10.297989-41.191955 9.098223-58.688538-3.299355-18.196446-12.897481-27.194689-34.693224-23.595391-56.98887l48.990431-299.341534L17.496583 445.512986C2.19957 429.816052-2.999414 407.020504 3.999219 385.924624c6.798672-20.495997 24.095294-35.193126 44.991213-38.392501L334.3347 304.140598 462.109744 32.593634C471.607889 12.497559 491.004101 0 512.899824 0c21.795743 0 41.291935 12.497559 50.6901 32.593634L691.464948 304.140598 976.809217 347.632103c20.895919 3.199375 38.192541 17.896505 44.991213 38.392502 6.998633 20.995899 1.799649 43.791447-13.497364 59.488381L801.043546 657.271627l48.990432 299.341534c3.699277 22.295645-5.398946 44.191369-23.595392 56.98887-9.598125 6.798672-20.795938 10.297989-31.993751 10.297989z" fill="#FF0000" p-id="2105"></path></svg>
          <svg v-else class="icon" height="100%" p-id="2104" t="1729222239914" version="1.1" viewBox="0 0 1025 1024" width="100%" xmlns="http://www.w3.org/2000/svg" @click="onCollectClick(true)"><path d="M794.444835 1023.90002c-9.098223 0-18.296426-2.299551-26.694786-6.898653L512.899824 876.428822l-254.850224 140.472564c-18.696348 10.297989-41.191955 9.098223-58.688538-3.299355-18.196446-12.897481-27.194689-34.693224-23.595391-56.98887l48.990431-299.341534L17.496583 445.512986C2.19957 429.816052-2.999414 407.020504 3.999219 385.924624c6.798672-20.495997 24.095294-35.193126 44.991213-38.392501L334.3347 304.140598 462.109744 32.593634C471.607889 12.497559 491.004101 0 512.899824 0c21.795743 0 41.291935 12.497559 50.6901 32.593634L691.464948 304.140598 976.809217 347.632103c20.895919 3.199375 38.192541 17.896505 44.991213 38.392502 6.998633 20.995899 1.799649 43.791447-13.497364 59.488381L801.043546 657.271627l48.990432 299.341534c3.699277 22.295645-5.398946 44.191369-23.595392 56.98887-9.598125 6.798672-20.795938 10.297989-31.993751 10.297989z" fill="#ffffff" p-id="2105"></path></svg>
          <span class="text-sm">{{ item.collect_num || 0 }}</span>
        </div>
        <div class="flex flex-col space-y-1 items-center copy-btn" data-clipboard-target="#copy-input" v-if="device !== 'pad'">
<!--          <van-icon class="text-3xl" color="#FFF" name="share" @click="onShareClick"/>-->
          <svg class="icon" height="100%" p-id="4496" t="1729221955778" version="1.1" viewBox="0 0 1024 1024" width="100%" xmlns="http://www.w3.org/2000/svg" @click="onShareClick"><path d="M1010.8 628c0-141.2-141.3-256.2-299.9-256.2-168 0-300.3 115.1-300.3 256.2 0 141.4 132.3 256.2 300.3 256.2 35.2 0 70.7-8.9 106-17.7l96.8 53-26.6-88.2c70.9-53.2 123.7-123.7 123.7-203.3zM618 588.8c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40c0 22-17.9 40-40 40z m194.3-0.3c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z" fill="#00CC5F" p-id="4497"></path><path d="M366.3 106.9c-194.1 0-353.1 132.3-353.1 300.3 0 97 52.9 176.6 141.3 238.4l-35.3 106.2 123.4-61.9c44.2 8.7 79.6 17.7 123.7 17.7 11.1 0 22.1-0.5 33-1.4-6.9-23.6-10.9-48.3-10.9-74 0-154.3 132.5-279.5 300.2-279.5 11.5 0 22.8 0.8 34 2.1C692 212.6 539.9 106.9 366.3 106.9zM247.7 349.2c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z m246.6 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z" fill="#00CC5F" p-id="4498"></path></svg>
          <span class="text-sm">分享</span>
        </div>
        <div v-if="item.comment_status == 1" class="flex flex-col space-y-1 items-center copy-btn" data-clipboard-target="#copy-input" @click="onCommentClick">
          <svg class="icon" data-spm-anchor-id="a313x.search_index.0.i13.7ca13a817tf88E" height="100%" p-id="5587" t="1731481856467" version="1.1" viewBox="0 0 1024 1024" width="100%" xmlns="http://www.w3.org/2000/svg"><path class="" d="M512 512m-450.56 0a450.56 450.56 0 1 0 901.12 0 450.56 450.56 0 1 0-901.12 0Z" data-spm-anchor-id="a313x.search_index.0.i10.7ca13a817tf88E" fill="#ffffff" p-id="5588"></path><path class="" d="M225.28 798.72h286.72v163.84H148.6848a40.96 40.96 0 0 1-27.19744-71.5776L225.28 798.72z" data-spm-anchor-id="a313x.search_index.0.i17.7ca13a817tf88E" fill="#ffffff" p-id="5589"></path><path class="selected" d="M276.48 512m-71.68 0a71.68 71.68 0 1 0 143.36 0 71.68 71.68 0 1 0-143.36 0Z" data-spm-anchor-id="a313x.search_index.0.i12.7ca13a817tf88E" fill="#2c2c2c" p-id="5590"></path><path class="selected" d="M512 512m-71.68 0a71.68 71.68 0 1 0 143.36 0 71.68 71.68 0 1 0-143.36 0Z" data-spm-anchor-id="a313x.search_index.0.i11.7ca13a817tf88E" fill="#2c2c2c" p-id="5591"></path><path class="selected" d="M747.52 512m-71.68 0a71.68 71.68 0 1 0 143.36 0 71.68 71.68 0 1 0-143.36 0Z" data-spm-anchor-id="a313x.search_index.0.i14.7ca13a817tf88E" fill="#2c2c2c" p-id="5592"></path></svg>
          <span class="text-sm">评论</span>
        </div>
        <div v-if="giftOtherData && item.gift_course_id != 0 && haveToken && device != 'ios'" class="flex flex-col space-y-1 items-center copy-btn">
          <img src="@/assets/img/gift-icon.png" alt="" class="icon gift-icon" @click="onGiveClick">
          <span class="text-sm">打赏</span>
        </div>
      </div>
    </div>
    <div class="info flex items-center absolute left-2 right-2 bottom-2 h-14">
      <div v-if="item.bottom_bar_status && item.teacher"  class="flex flex-1 h-full" @click="onClickBottom">
        <div class="avatar">
          <img :src="item.teacher.img_small_url" alt="">
        </div>
        <div class="message text-white">
          <p class="truncate text-xl">{{ item.teacher.name }}</p>
          <p class="text-sm text-gray-400">执业证书: {{item.teacher.number}}</p>
        </div>
      </div>
      <div v-else class="h-full flex-1"></div>
      <div :class="{'have-left-border': item.bottom_bar_status && item.teacher}" class="flex flex-col justify-center text-white items-center h-full" @click="onClickKf">
        <van-icon class="mb-1" color="#FFF" name="service-o" size="24"/>
        <span class="text-sm">客服</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.player-container {
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
  border-bottom: 1px solid #EFEFF4;
}

.player-container_inner {
  position: relative;
  width: 100%;
  /*height: 100%;*/
}

.player-container_inner_video {
  /*
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  */
  width: 100%;
}

.player-container_inner video {
  width: 100%;
  max-height: 100%;
  object-fit: fill;
}

.video-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btns {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 99;
}

.btns .btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #EFEFF4;
  border-radius: 1rem;
  background-color: rgba(255,255,255,0.2);
  box-sizing: border-box;
}

.btns .btn span {
  margin-left: 0.5rem;
}

.info .avatar img {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  margin-right: 0.5rem;
}

.gift-icon {
  animation: jump 1s infinite ease-in-out; /* 应用跳动动画 */
}

.have-left-border {
  @apply border-l border-gray-400 pl-4;
}

@keyframes jump {
  0%, 100% {
    transform: translateY(0) rotateZ(0deg);
  }

  25% {
    transform: translateY(-4px) rotateZ(-5deg);
  }

  50% {
    transform: translateY(0) rotateZ(0deg);
  }

  75% {
    transform: translateY(-8px) rotateZ(5deg);
  }
}

.icon {
  width: 1.875rem;
  height: 1.875rem;
}
</style>
